document.addEventListener("DOMContentLoaded", function() {
  const itemsGpt234 = document.querySelectorAll(".accordion-gpt234 button");

  function toggleAccordionGpt234() {
    const itemToggleGpt234 = this.getAttribute('aria-expanded');
    
    for (let i = 0; i < itemsGpt234.length; i++) {
      itemsGpt234[i].setAttribute('aria-expanded', 'false');
    }
    
    if (itemToggleGpt234 == 'false') {
      this.setAttribute('aria-expanded', 'true');
    }
  }
  
  itemsGpt234.forEach(item => item.addEventListener('click', toggleAccordionGpt234));
});